import { defineStore } from 'pinia';
import { httpAPI } from '@/services/ajax';
import { useAlertStore } from './alert';
import { shouldShowError } from '@/utils/errorHelper';
import app from '@/main.js';

export const useAreaStore = defineStore('area', {
    state: () => ({
        areas: [],

        fetching: false,
        fetchPromise: null,
    }),
    actions: {
        fetchAreas() {
            // If we're already fetching, return the actual fetching promise
            if (this.fetching && this.fetchPromise) {
                return this.fetchPromise;
            }

            this.fetching = true;
            const url =
                app.config.globalProperties.$env.apiRoot + 'audit-area/read';
            const vm = this;

            const params = {
                fields: ['id', 'name'],
                order_by: { name: 'asc' },
            };

            this.fetchPromise = httpAPI(
                url,
                params,
                'GET',
                app.config.globalProperties.$router
            )
                .then((response) => {
                    if (response.success) {
                        vm.areas = response.data || [];
                    } else if (shouldShowError(response)) {
                        const alertStore = useAlertStore();
                        alertStore.pushError(
                            'Failed to fetch areas: ' +
                                (response?.message || 'Unknown error')
                        );
                    }
                    return vm.areas;
                })
                .catch((error) => {
                    const alertStore = useAlertStore();
                    alertStore.pushError(
                        'Unable to load areas. Please refresh the page.' +
                            (error?.message ? ': ' + error.message : '')
                    );
                    vm.areas = [];
                    return vm.areas;
                })
                .finally(() => {
                    vm.fetching = false;
                    vm.fetchPromise = null;
                });

            return this.fetchPromise;
        },
        syncAreas() {
            if (this.areas && this.areas.length > 0) {
                return Promise.resolve(this.areas);
            }
            return this.fetchAreas();
        },
        clear() {
            this.areas = [];
            this.fetching = false;
            this.fetchPromise = null;
        },
    },
    getters: {
        getAreaOptions(state) {
            return state.areas.map((area) => ({
                text: area.name,
                value: String(area.id),
            }));
        },
    },
});
